import type { Boards } from '../../model/index.tsx';
import getAssociatedBoards from '../../rest/get-associated-boards/index.tsx';
import { transformResponse } from './transformers.tsx';

const getBoards = async (filterId: string): Promise<Boards> => {
	const response = await getAssociatedBoards(filterId);
	return transformResponse(response);
};

export default getBoards;
